import React from 'react';
import PropTypes from 'prop-types';
// Models
import mPartner from 'models/cpm/partner';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import {
  listFeatureSearchFieldShape,
  listFilterShape,
} from 'constants/PropTypesShapes';
// Components
import FiltersCardTemplate from 'components/templates/FiltersCardTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';

const PartnerFilters = ({
  disabled,
  advanced,
  nbFiltersApplied,
  searchFields,
  field,
  filters: {
    emailForCommissionInvoices,
    europeanVatNumber,
    iban,
    invoiceIdentifier,
    name,
    nationalIdentifier,
  },
  isFieldDisplayable,
  onFieldChange,
  onFilterFieldChange,
  onReinit,
  onSwitch,
}) => (
  <div className="px-3 mb-3">
    <FiltersCardTemplate
      disabled={disabled}
      advanced={advanced}
      nbFiltersApplied={nbFiltersApplied}
      onReinit={onReinit}
      onSwitch={onSwitch}
    >
      <React.Fragment>
        {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter
              field={field}
              searchFields={searchFields}
              onChange={onFieldChange}
            />
          </div>
        )}
        {/* ----- name ----- */}
        {isFieldDisplayable('name') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.name"
              value={name.value}
              onChange={(value) => onFilterFieldChange('name', value)}
            />
          </div>
        )}
        {/* ----- emailForCommissionInvoices ----- */}
        {isFieldDisplayable('emailForCommissionInvoices') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.emailForCommissionInvoices"
              value={emailForCommissionInvoices.value}
              onChange={(value) => onFilterFieldChange('emailForCommissionInvoices', value)}
            />
          </div>
        )}
        {/* ----- nationalIdentifier ----- */}
        {isFieldDisplayable('nationalIdentifier') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.nationalIdentifier"
              value={nationalIdentifier.value}
              onChange={(value) => onFilterFieldChange('nationalIdentifier', value)}
            />
          </div>
        )}
        {/* ----- europeanVatNumber ----- */}
        {isFieldDisplayable('europeanVatNumber') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.europeanVatNumber"
              value={europeanVatNumber.value}
              onChange={(value) => onFilterFieldChange('europeanVatNumber', value)}
            />
          </div>
        )}
        {/* ----- invoiceIdentifier ----- */}
        {isFieldDisplayable('invoiceIdentifier') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.invoiceIdentifier"
              value={invoiceIdentifier.value}
              onChange={(value) => onFilterFieldChange('invoiceIdentifier', value)}
            />
          </div>
        )}
        {/* ----- iban ----- */}
        {isFieldDisplayable('iban') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.iban"
              value={iban.value}
              onChange={(value) => onFilterFieldChange('iban', value)}
            />
          </div>
        )}
      </React.Fragment>
    </FiltersCardTemplate>
  </div>
);

PartnerFilters.propTypes = {
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    emailForCommissionInvoices: listFilterShape,
    europeanVatNumber: listFilterShape,
    iban: listFilterShape,
    invoiceIdentifier: listFilterShape,
    name: listFilterShape,
    nationalIdentifier: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(mPartner.listFeatures.searchFields)(
  PartnerFilters,
);



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/partner/PartnerFilters.js